import { Component } from '@theme/component';

// Create a new custom element for product links with images for transitions to PDP
class ProductCardLink extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#handleClick);
  }

  get productTransitionEnabled() {
    return this.getAttribute('data-product-transition') === 'true';
  }

  get featuredMediaUrl() {
    return this.getAttribute('data-featured-media-url');
  }

  /**
   * Handles the click event for the product link
   * @param {Event} event
   */
  #handleClick = (event) => {
    // If the event has been prevented, don't do anything, another component is handling the click
    if (event.defaultPrevented) return;

    // If the event was on an interactive element, don't do anything, this is not a navigation
    if (event.target instanceof Element) {
      const interactiveElement = event.target.closest('button, input, label, select, [tabindex="1"]');
      if (interactiveElement) return;
    }

    const gallery = this.querySelector('[data-view-transition-to-main-product]');
    if (!this.productTransitionEnabled || !(gallery instanceof HTMLElement)) return;

    // Check on the current active image, whether it's a product card image or a resource card image
    const activeImage =
      gallery.querySelector('slideshow-slide[aria-hidden="false"] [transitionToProduct="true"]') ||
      gallery.querySelector('[transitionToProduct="true"]:last-child');

    if (activeImage instanceof HTMLImageElement) this.#setImageSrcset(activeImage);

    gallery.setAttribute('data-view-transition-type', 'product-image-transition');
    gallery.setAttribute('data-view-transition-triggered', 'true');
  };

  /**
   * Sets the srcset for the image
   * @param {HTMLImageElement} image
   */
  #setImageSrcset(image) {
    if (!this.featuredMediaUrl) return;

    const currentImageUrl = new URL(image.currentSrc);

    // Deliberately not using origin, as it includes the protocol, which is usually skipped for featured media
    const currentImageRawUrl = currentImageUrl.host + currentImageUrl.pathname;

    if (!this.featuredMediaUrl.includes(currentImageRawUrl)) {
      const imageFade = image.animate([{ opacity: 0.8 }, { opacity: 1 }], {
        duration: 125,
        easing: 'ease-in-out',
      });

      imageFade.onfinish = () => {
        image.srcset = this.featuredMediaUrl ?? '';
      };
    }
  }
}

if (!customElements.get('product-card-link')) {
  customElements.define('product-card-link', ProductCardLink);
}


/* seronine-meta-inapp-asset-navigation-fix-20260610: IG/Facebook in-app browser native navigation fallback only. */
(function () {
  var ua = navigator.userAgent || '';
  if (!/Instagram|FBAN|FBAV|FB_IAB/i.test(ua) || window.__seronineMetaInappAssetNavigationFix) return;
  window.__seronineMetaInappAssetNavigationFix = true;

  function closestAnchor(target) {
    return target && target.closest && target.closest('a[href]');
  }

  function shouldHandle(anchor) {
    if (!anchor) return false;
    if (!anchor.matches('.seronine-shop-panel__menu a[href], .seronine-purchase-shop__menu a[href], .seronine-purchase-card__image[href], .seronine-purchase-card__title[href], product-card a[href], product-card-link a[href]')) return false;
    var href = anchor.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|sms:|javascript:)/i.test(href)) return false;
    if (anchor.hasAttribute('download')) return false;
    var url;
    try { url = new URL(href, window.location.href); } catch (e) { return false; }
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return false;
    return url;
  }

  function nativeNavigate(event) {
    var anchor = closestAnchor(event.target);
    var url = shouldHandle(anchor);
    if (!url) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    var blocker = document.getElementById('view-transition-render-blocker');
    if (blocker && blocker.parentNode) blocker.parentNode.removeChild(blocker);
    window.location.assign(url.href);
  }

  ['touchend', 'pointerup', 'click'].forEach(function (type) {
    document.addEventListener(type, nativeNavigate, true);
  });
})();
